<div class="container-grid">
    <div class="table-container">
        <table mat-table [dataSource]="dataSource">
            @for (column of columns; track column; let i = $index) {
                <ng-container matColumnDef="{{column}}">
                    @if (hasHeading(column)) {
                        <th mat-header-cell *matHeaderCellDef [attr.colspan]="getHeadingWidth(column)" [style]="getHeaderStyle(column)"> {{headings[column]}} </th>
                    }
                    <td mat-cell *matCellDef="let element" [style]="getNumberStyle(element, column)">
                        @if (column === 'icons') {
                            <span class="icons">
                            @for (icon of element[column]; track icon) {
                                <app-node-svg [type]="icon" [noText]="true" [height]="24"/>
                            }
                            </span>
                        }@else if (column === 'name') {
                            {{element[column]}}
                        }@else if (column === 'colour') {
                            <span class="box" [style]="'background-color: ' + getColour(element.rowType)"></span>
                        }@else {
                            @if (column === 'cost') {
                                {{element.getValue(column) | currency: currencyCode: 'symbol-narrow': '1.0-0'}}
                            }@else {
                                {{element.getValue(column) | number}}
                            }
                            {{getPercentage(element, column, i)}}
                        }
                    </td>
                    @if (column === 'icons' || column == 'colour') {
                        <td mat-footer-cell *matFooterCellDef></td>
                    }@else if (column === 'name') {
                        <td mat-footer-cell *matFooterCellDef> Total </td>
                    }@else if (column === 'cost') {
                        <td mat-footer-cell *matFooterCellDef [style]="getHeaderStyle(column)"> {{totals[i] | currency: currencyCode: 'symbol-narrow': '1.0-0'}} </td>
                    }@else {
                        <td mat-footer-cell *matFooterCellDef [style]="getHeaderStyle(column)"> {{totals[i] | number}} </td>
                    }
                </ng-container>
            }

            <tr mat-header-row *matHeaderRowDef="getHeadings()"></tr>
            <tr mat-row *matRowDef="let element; columns: columns;" (click)="selectRow(element); $event.stopPropagation()" [ngClass]="{'selected-row': element.rowType === selectedType}"></tr>
            <tr mat-footer-row *matFooterRowDef="columns"></tr>
        </table>
  </div>

  <!--div class="chart-container">
    @if (barData && barData.length > 0) {
      @for (d of barData; track d.name) {
        <app-bar-chart [data]="d.data" [comparison]="comparisonName" [isStacked]="true" [stacks]="stacks" [height]="90" [width]="450" [hideLegend]="true"></app-bar-chart>
      }
    }
  </div-->
</div>
